import { Component } from '@angular/core';

@Component({
  selector: 'csp-webapp',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {}
